import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";
import { useEffect, useState } from "react";
import { getOrganizationDocumentations } from "../../../../../setup/api/services/organization";
import { IOrganizations } from "../../../../../setup/types/Organisation";
import Spinner from "../../../../../components/common/Spinner";
import { IOrganizationDocumentation } from "../../../../../setup/api/services/organization/models";
import PDFComponent from "../../../../../components/common/PDFComponent";
import DenyAccess from "../../../balance/denyAccess";

interface DocumentationInformationProps {
  organization: IOrganizations | undefined;
}

const DocumentationInformation = ({
  organization,
}: DocumentationInformationProps) => {
  const { t } = useTranslation();
  const [documentations, setDocumentations] = useState<
    IOrganizationDocumentation[]
  >([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!organization) return;
    const fetchDocumentations = async () => {
      setIsLoading(true);
      try {
        const response = await getOrganizationDocumentations(organization.code);
        setDocumentations(response.data);
      } catch (error: any) {
        setError(error?.error?.message);
        console.error("Error fetching documentation information:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDocumentations();
  }, [organization]);

  if (isLoading) {
    return (
      <div className={styles.spinnerContainer}>
        <Spinner />
      </div>
    );
  }

  if (error === "Access is denied") {
    return <DenyAccess />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <h3 className={styles.title}>{t("lbl_documentation_info_title")}</h3>
      </div>
      <div className={styles.contentContainer}>
        {documentations.map((doc) => (
          <div key={doc.id} className={styles.documentationItem}>
            <p className={styles.documentationTitle}>{doc.title}</p>
            <PDFComponent
              key={doc.id}
              isHorizontalPDF
              fileUrl={doc.attachmentUrl}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentationInformation;
